/**
 * Local time, like `formatDateTime`: a moment with an hour on it is read as "when,
 * for me". Unlike `formatDateTime` it carries the year, because the queue and the
 * ticket detail aren't bounded by a chosen period — a ticket can be months old.
 */
const CREATED_FMT = new Intl.DateTimeFormat('en-GB', {
	day: 'numeric',
	month: 'short',
	year: 'numeric',
	hour: '2-digit',
	minute: '2-digit',
	hour12: false,
});

/**
 * The moment a ticket was created (or closed) — `14 Aug 2026, 09:55`. Absolute, not
 * "2w ago": once a ticket is more than a few days old the relative reading stops
 * being useful for SLA discussions, month-end reconciliation and replying to a
 * customer, all of which need the actual date.
 *
 * Returns an em-dash for a missing or unparseable timestamp.
 */
export function formatCreated(isoDate: string | null | undefined): string {
	if (!isoDate) return '—';
	const created = new Date(isoDate);
	if (isNaN(created.getTime())) return '—';
	return CREATED_FMT.format(created);
}
